import React, { useState, useContext, useEffect } from 'react';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import AuthContext from '../../context/auth/authContext';
import '../../styles/auth.css';

const Login = () => {
  const authContext = useContext(AuthContext);
  const { login, error, clearErrors, isAuthenticated } = authContext;
  const navigate = useNavigate();
  const location = useLocation();
  const [tokenExpired, setTokenExpired] = useState(false);

  const [user, setUser] = useState({
    email: '',
    password: ''
  });

  const { email, password } = user;

  useEffect(() => {
    // Check if redirected due to token expiration
    const params = new URLSearchParams(location.search);
    if (params.get('expired') === 'true') {
      setTokenExpired(true);
      // Show a toast notification
      toast.info('Your session expired. Please log in again.');
    }

    if (isAuthenticated) {
      navigate('/dashboard');
    }

    if (error) {
      toast.error(error);
      clearErrors();
    }
  }, [error, isAuthenticated, navigate, clearErrors, location.search]);

  const onChange = e => setUser({ ...user, [e.target.name]: e.target.value });

  const onSubmit = e => {
    e.preventDefault();
    login({
      email,
      password
    });
  };

  return (
    <div className="auth-page page-narrow">
      <div className="auth-card">
        <div className="form-container">
          <div className="auth-logo">
            <img
              src="/Logo-with-slogan.png"
              alt="PokeMatch Logo"
              style={{ maxWidth: '300px', width: '100%', marginBottom: '20px' }}
            />
          </div>
          <h1>
            Account <span className="text-primary">Login</span>
          </h1>
          {tokenExpired && (
            <div className="auth-alert">
              Your session has expired. Please log in again.
            </div>
          )}
          <form onSubmit={onSubmit}>
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                type="email"
                name="email"
                className="form-control"
                value={email}
                onChange={onChange}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="password">Password</label>
              <input
                type="password"
                name="password"
                className="form-control"
                value={password}
                onChange={onChange}
                required
              />
            </div>
            <input type="submit" value="Login" className="btn btn-primary btn-block" />
          </form>
          <div className="auth-links">
            <p>Don't have an account? <Link to="/register">Register</Link></p>
            <p><Link to="/forgot-password">Forgot your password?</Link></p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
